import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AccountService } from './account.service';

export const authInterceptorFn: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const account = inject(AccountService);

    // Determina se la richiesta è verso il backend (passa dal proxy)
    const url = req.url;
    const isBackend =
        url.startsWith('/api') || url.startsWith('api') ||
        url.startsWith('/services/') || url.startsWith('services/');

    // Clona con withCredentials sempre
    let cloned = req.clone({ withCredentials: true });

    // Setta gli header "json" solo se NON è FormData
    if (!(req.body instanceof FormData)) {
        cloned = cloned.clone({
            setHeaders: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });
    }

    if (isBackend && cloned.headers.has('Authorization')) {
        const headersSansAuth = cloned.headers.delete('Authorization');
        cloned = cloned.clone({ headers: headersSansAuth });
    }

    return next(cloned).pipe(
        catchError((err) => {
            console.error('AuthInterceptor - HTTP Error:', err.status, err.message);

            // status 0 = CORS error: accade quando il backend fa redirect 302 verso OAuth (es. Azure)
            // e il proxy segue il redirect verso un endpoint senza header CORS configurati
            const isUnauth = err.status === 401
                || err.status === 302
                || (err.status === 0 && isBackend)
                || (err.status === 404 && err.url?.includes('/oauth2/authorization'));

            if (isUnauth && !req.url.includes('/auth/login')) {
                account.clearAuth();
                router.navigate(['/auth/login']);
            }

            return throwError(() => err);
        })
    );
};
